<template>
  <div class="container">
    <div class="j-title title">{{ $t('about_us.factory_show_title') }}</div>
    <div class="carousel-container">
      <a-carousel
        v-if="factories.length > 0"
        arrows
        :afterChange="handleAfterChange"
        dots-class="slick-dots slick-thumb"
      >
        <template #prevArrow>
          <div class="custom-slick-arrow" style="left: -62px;zIndex: 1">
            <LeftOutlined />
          </div>
        </template>
        <template #nextArrow>
          <div class="custom-slick-arrow" style="right: -62px">
            <RightOutlined />
          </div>
        </template>
        <div class="img-container" v-for="f in factories" :key="f.id">
          <img alt="pic" :src="baseUrl + f.newsImageUrl" />

          <div class="img-info j-content">
            {{ $t(f.title) }}
          </div>
        </div>

        <template #customPaging="props">
          <a :style="getStyle(props.i)">
            <img :src="getImgUrl(props.i)" />
          </a>
        </template>
      </a-carousel>

      <div
        v-if="loaded && factories.length === 0"
        class="j-coming-soon j-content"
      >
        {{ $t('common.coming_soon') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue';
import { baseUrl } from '@/utils/constants';

export default defineComponent({
  name: 'FactoryShow',
  components: {
    LeftOutlined,
    RightOutlined
  },
  data() {
    return {
      baseUrl,
      currentSlide: 1
    };
  },
  props: {
    factories: {
      type: Array,
      required: true,
      default: () => []
    },
    loaded: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  methods: {
    getStyle(i: number) {
      const index = i + 1;
      if (this.currentSlide > 4) {
        // const reminder = this.currentSlide % 4;

        const sIndex = this.currentSlide - 3;
        if (index >= sIndex && index <= this.currentSlide) {
          return { display: 'block' };
        }
        return { display: 'none' };

        // if (reminder === 0) {
        //   const factor = this.currentSlide / 4;
        //   const sIndex = (factor - 1) * 4 + 1;
        //   if (index >= sIndex && index <= this.currentSlide) {
        //     return { display: 'block' };
        //   }
        //   return { display: 'none' };
        // } else if (
        //   (this.currentSlide % 4) - index < 0 &&
        //   this.currentSlide - index >= 0
        // ) {
        //   return { display: 'block' };
        // }
        // return { display: 'none' };
      } else {
        if (index > 4) {
          return { display: 'none' };
        }

        return { display: 'block' };
      }
    },
    getImgUrl(i: number) {
      return baseUrl + (this.factories[i] as any).newsImageUrl;
    },
    handleAfterChange(current: number) {
      this.currentSlide = current + 1;
    }
  }
});
</script>

<style lang="scss" scoped>
.container {
  max-width: 1024px;
  margin: 0 auto;
  margin-bottom: 80px;

  .title {
    margin-bottom: 30px;

    text-align: center;
  }

  .carousel-container {
    margin-bottom: 20px;

    .img-container {
      position: relative;
      display: flex !important;
      justify-content: center;
      height: 512px; // 避免过高

      .img-info {
        background: #000000;
        text-align: center;
        opacity: 0.6;
        padding: 10px;
        position: absolute;
        bottom: 0;
        width: 100%;
        color: white;
      }
    }
  }
}

.ant-carousel ::v-deep(.slick-slide) {
  overflow: hidden;
}

.ant-carousel ::v-deep(.slick-dots) {
  position: relative;
  height: auto;
}

.ant-carousel ::v-deep(.slick-slide img) {
  /* border: 5px solid #fff; */
  display: block;
  margin: auto;
  width: 100%;
  height: 100%;
}

.ant-carousel ::v-deep(.slick-thumb) {
  bottom: 0px;
  margin-top: 16px;
}

.ant-carousel ::v-deep(.slick-thumb li) {
  margin: 0;
}

.ant-carousel ::v-deep(.slick-thumb li a) {
  width: 120px;
  height: 60px;
  margin: 0 10px;
  border-radius: 1px;
  display: block;
}

.ant-carousel ::v-deep(.slick-thumb li img) {
  width: 100%;
  height: 100%;
  filter: grayscale(80%);
}

.ant-carousel ::v-deep .slick-thumb li.slick-active img {
  filter: grayscale(0%);
}

.ant-carousel ::v-deep(.slick-arrow.custom-slick-arrow) {
  width: 40px;
  height: 40px;
  color: #fff;
  font-size: 25px;
  background-color: $primary-color;
  display: flex !important;
  align-items: center;
  justify-content: center;
  top: calc(50% - 76px);

  &:hover {
    background-color: $primary-hover-color;
  }
}
.ant-carousel ::v-deep(.custom-slick-arrow:before) {
  display: none;
}
</style>
